export const liveStatusUrl = 'live-status/';
